//import InputResolver from "wprr/manipulation/animation/inputresolvers/InputResolver";
export default class InputResolver {

	constructor() {
		
	}
	
	resolveValue(aValues, aElement) {
		//MENOTE: should be overridden
		
		return null;
	}
}
